import SupplierForm from '../components/SupplierForm';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useGetSupplierHandler } from '../dataHandlers/getSupplierHandler';
import { useMutateSupplierHandler } from '../dataHandlers/mutateSupplierHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import React, { useState, useEffect } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_SUPPLIER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function EditSupplierPage() {
  const navigate = useNavigate();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { profile_id } = useParams();
  const onSuppliersCreated = () => {
    navigate('/suppliers');
  };

  function handleCancel() {
    return navigate('/suppliers');
  }

  const { supplier, isLoading: isLoadingData } = useGetSupplierHandler(profile_id);
  const { onSubmit, error, isPending } = useMutateSupplierHandler({ onSuccess: onSuppliersCreated });

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!hasEInvoicePermission(UPDATE_SUPPLIER)) {
      showActionDeniedSnackbar();
      navigate('/suppliers', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);


  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    onSubmit(payload, true);
  };

  if (isLoadingData || !supplier) return <DocumentSkeletonForm />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SupplierForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={supplier}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
      ></SupplierForm>
    </Stack>
  );
}
